//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import { mapGetters } from "vuex";
import FabricSearch from "@/components/q-fabric-search.vue";
import AQRowCard from "@/components/Generics/AQRowCard/AQRowCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import ImportSelectedPluginConditions from "./ImportSelectedPluginConditions.vue";

export default {
    components: {
        AQChip,
        AQRowCard,
        AQModal,
        AQCard,
        FabricSearch,
        ImportSelectedPluginConditions
    },
    data() {
        return {
            allActivities: [],
            filtredActivities: [],
            searchActivity: "",
            importConditions: true,
            showPluginConditions: false
        };
    },
    computed: {
        ...mapGetters("diagrams", [
            "selectedPluginConfigData",
            "diagramConfigData"
        ])
    },
    created() {
        this.diagramConfigData.content.forEach(activity => {
            if (
                ((activity.pluginType === "TASK_PLUGIN"
                    || activity.pluginType === "APPROVAL_PLUGIN"
                    || activity.pluginType === "EXTERNAL_SOURCE_PLUGIN")
                    && activity.rules
                    && activity.rules.length)
                || (activity.levels && activity.levels.length)
                || ((activity.pluginType === "BLOCKCHAIN_EVENT_PLUGIN" || activity.pluginType === "START_BLOCKCHAIN_EVENT_PLUGIN")
                    && activity.blockchainEvent.rules
                    && activity.blockchainEvent.rules.length)
                || (activity.pluginType === "API_PLUGIN"
                    && activity.apiConfigure
                    && activity.apiConfigure.responses.length)
                || (activity.pluginType === "EXPOSE_API_PLUGIN"
                    && activity.apiConfigure
                    && activity.apiConfigure.actionRules.length)
            ) {
                this.filtredActivities.push(activity);
            }
        });
        this.diagramConfigData.connectors.forEach(connector => {
            if (
                connector.notificationRules
                && connector.notificationRules.length
            ) {
                this.filtredActivities.push(connector);
            }
        });
        this.allActivities = this.filtredActivities;
    },
    methods: {
        searchActivityByName(value) {
            const searchValue = value.toLowerCase();
            this.filtredActivities = this.allActivities.filter(activity => activity.label.toLowerCase().includes(searchValue));
        },
        showActivityRules(selectedActivity) {
            this.selectedActivity = selectedActivity;
            this.showPluginConditions = true;
        },
        actionsDlg(event) {
            if (event === "close") {
                this.$emit("input", false);
            }
        },
        importSelectedRule(selectedRule) {
            this.$emit("importSelectedRule", selectedRule);
            this.$emit("input", false);
        }
    }
};
